import { Switch, Route, Redirect } from 'react-router-dom';
import { useUserAuth } from '../state/userAuthContext';
import { countriesListLegacyRoutes, countriesListRoutes, Route as AppRoute } from './allRoutes';
import useOnlyDevelopers from 'state/setOnlyDevelopers';

const getSwitchRoutes = (routes: AppRoute[]) => (
  <Switch>
    {routes.map((prop, key) => {
      if (prop.layout === 'country') {
        return <Route path={`/${prop.layout}${prop.path}`} component={prop.component} key={key} exact />;
      }
      return null;
    })}
    <Redirect from="/country" to="/country/listing" />
  </Switch>
);

const Countries = () => {
  const { user } = useUserAuth();
  const { isOnlyDevsLogistics } = useOnlyDevelopers();
  const activeRoutes = isOnlyDevsLogistics ? countriesListRoutes : countriesListLegacyRoutes;

  return <> {user && getSwitchRoutes(activeRoutes)} </>;
};

export default Countries;
